import React from 'react';
import OpenApiElements from '@/components/OpenApiElements';
import './index.less';

export default () => (
  <OpenApiElements apiDescriptionUrl={process.env.REACT_APP_CHANNEL_APP_HOST} />
);
